export type H2Props = Readonly<{
  children: React.JSX.Element | string | (React.JSX.Element | string)[];
  className?: string;
}>;

const style = {
  marginBottom: '2rem',
  fontSize: '1.6rem',
};

const H2 = (props: H2Props) => (
  <h2 css={style} className={props.className}>{props.children}</h2>
);

export default H2;
